var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',{attrs:{"id":_vm.site}},_vm._l((_vm.page.components),function(c){return _c(c.name,_vm._b({key:c.id,tag:"component",on:{"sectionChanged":_vm.sectionChanged}},'component',c,false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }